import theme, {
    TypographyWeights 
} from '../../../../../figmaTheme';
import {
    END_GOALS 
} from '../../../config/types';
import CircleTakeover from '../../../screens/animations/circleTakeover';
import GoalsQuote from '../../../screens/animations/goalsQuote';
import GoalsSection from '../../../screens/animations/goalsSection';
import GoalSteps from '../../../screens/animations/goalSteps';
import ScienceExplainer from '../../../screens/animations/scienceExplainer';
import SectionIntro from '../../../screens/animations/sectionIntro';
import TopGoal from '../../../screens/animations/topGoal';
import GoalsChoiceScreen from '../../../screens/goalsChoice';
import MultipleChoiceScreen from '../../../screens/multipleChoice';
import NameInputScreen from '../../../screens/nameInput';

export const GOALS_SCREENS = [
    {
        key: 'goals section',
        trackingName: 'goals section',
        screenName: 'goals section',
        component: (
            <GoalsSection />
        )
    },
    {
        key: 'goals section intro',
        screenName: 'goals section intro',
        component: (
            <SectionIntro
                sectionKey={'goals'}
                subtitle={'We\'ll start by learning about your high-level goals for healthier drinking.'}
            />
        )
    },
    {
        key: 'goals choices',
        screenName: 'goals choices',
        component: (
            <GoalsChoiceScreen
                position={1}
                backJump={2}
            />
        )
    },
    {
        key: 'top goal graph',
        trackingName: 'top goal explainer',
        screenName: 'top goal graph',
        component: (
            <TopGoal
                position={3}
            />
        )
    },
    {
        key: 'top goal science',
        trackingName: 'top goal science',
        screenName: 'top goal science',
        component: (
            <ScienceExplainer
                position={4}
            />
        )
    },
    {
        key: 'top goal steps',
        trackingName: 'top goal points',
        screenName: 'top goal steps',
        component: (
            <GoalSteps
                position={5}
            />
        )
    },
    {
        key: 'end goal',
        trackingName: 'end goal',
        screenName: 'end goal',
        component: (
            <MultipleChoiceScreen
                position={6}
                sectionKey={'goals'}
                answerKey={'endGoal'}
                title={`What's your <span style="color:${theme.palette.primary.main};font-weight:${TypographyWeights.BOLD};">ideal outcome</span> when it comes to changing your relationship with alcohol?`}
                choices={END_GOALS}
            />
        )
    },
    {
        key: 'end goal explainer 1',
        trackingName: 'end goal explainer',
        screenName: 'end goal explainer',
        component: (
            <CircleTakeover
                position={7}
                sectionKey={'goals'}
                title={'Great! We\'ll design your plan around drinking less without quitting entirely.'}
                body={'85% of Sunnyside members are also working towards this goal. You\'re in good company!'}
                backJump={1}
                forwardJump={3}
            />
        )
    },
    {
        key: 'end goal explainer 2',
        trackingName: 'end goal explainer',
        screenName: 'end goal explainer',
        component: (
            <CircleTakeover
                position={7}
                sectionKey={'goals'}
                title={'Great! We\'ll design your plan around eventually cutting alcohol out entirely.'}
                body={'The latest scientific guidelines point to cutting alcohol out entirely as the healthiest option. We\'ll get you to this goal at a pace that feels comfortable for you.'}
                backJump={2}
                forwardJump={2}
            />
        )
    },
    {
        key: 'end goal explainer 3',
        trackingName: 'end goal explainer',
        screenName: 'end goal explainer',
        component: (
            <CircleTakeover
                position={7}
                sectionKey={'goals'}
                title={'No worries! We\'ll start your plan with a gradual reduction in drinks, and can determine next steps from there.'}
                body={'97% of Sunnyside members report drinking less since joining Sunnyside. You\'re in good company!'}
                backJump={3}
                forwardJump={1}
            />
        )
    },
    {
        key: 'goals section quote',
        trackingName: 'goals section quote',
        screenName: 'goals section quote',
        component: (
            <GoalsQuote />
        )
    }
];

export const GOALS_SCREENS_V2 = [
    {
        key: 'goals section',
        trackingName: 'goals section',
        screenName: 'goals section',
        component: (
            <GoalsSection />
        )
    },
    {
        key: 'goals section intro',
        screenName: 'goals section intro',
        component: (
            <SectionIntro
                sectionKey={'goals'}
                subtitle={'We\'ll start by learning about your high-level goals for healthier drinking.'}
            />
        )
    },
    {
        key: 'name input',
        trackingName: 'your_name',
        screenName: 'name input',
        component: (
            <NameInputScreen
                key={'name input'}
                position={1}
                sectionKey={'goals'}
                backJump={2}
            />
        )
    },
    {
        key: 'goals choices',
        screenName: 'goals choices',
        component: (
            <GoalsChoiceScreen
                position={2}
            />
        )
    },
    {
        key: 'top goal graph',
        trackingName: 'top goal explainer',
        screenName: 'top goal graph',
        component: (
            <TopGoal
                position={4}
            />
        )
    },
    {
        key: 'top goal science',
        trackingName: 'top goal science',
        screenName: 'top goal science',
        component: (
            <ScienceExplainer
                position={5}
            />
        )
    },
    {
        key: 'top goal steps',
        trackingName: 'top goal points',
        screenName: 'top goal steps',
        component: (
            <GoalSteps
                position={6}
            />
        )
    },
    {
        key: 'end goal',
        trackingName: 'end goal',
        screenName: 'end goal',
        component: (
            <MultipleChoiceScreen
                position={7}
                sectionKey={'goals'}
                answerKey={'endGoal'}
                title={`What's your <span style="color:${theme.palette.primary.main};font-weight:${TypographyWeights.BOLD};">ideal outcome</span> when it comes to changing your relationship with alcohol?`}
                choices={END_GOALS}
            />
        )
    },
    {
        key: 'end goal explainer 1',
        trackingName: 'end goal explainer',
        screenName: 'end goal explainer',
        component: (
            <CircleTakeover
                position={8}
                sectionKey={'goals'}
                title={'Great! We\'ll design your plan around drinking less without quitting entirely.'}
                body={'85% of Sunnyside members are also working towards this goal. You\'re in good company!'}
                backJump={1}
                forwardJump={3}
            />
        )
    },
    {
        key: 'end goal explainer 2',
        trackingName: 'end goal explainer',
        screenName: 'end goal explainer',
        component: (
            <CircleTakeover
                position={8}
                sectionKey={'goals'}
                title={'Great! We\'ll design your plan around eventually cutting alcohol out entirely.'}
                body={'The latest scientific guidelines point to cutting alcohol out entirely as the healthiest option. We\'ll get you to this goal at a pace that feels comfortable for you.'}
                backJump={2}
                forwardJump={2}
            />
        )
    },
    {
        key: 'end goal explainer 3',
        trackingName: 'end goal explainer',
        screenName: 'end goal explainer',
        component: (
            <CircleTakeover
                position={8}
                sectionKey={'goals'}
                title={'No worries! We\'ll start your plan with a gradual reduction in drinks, and can determine next steps from there.'}
                body={'97% of Sunnyside members report drinking less since joining Sunnyside. You\'re in good company!'}
                backJump={3}
                forwardJump={1}
            />
        )
    },
    {
        key: 'goals section quote',
        trackingName: 'goals section quote',
        screenName: 'goals section quote',
        component: (
            <GoalsQuote />
        )
    }
];
